import { Button } from 'components/ui';

import { ButtonContainer, ModalBody, StyledModal } from './UploadInspectionDataModal.style';

interface ICancelUploadModalProps {
  open: boolean;
  handleContinue: () => void;
  handleCancel: () => void;
  rollback: {
    update: (toastMessage?: string) => Promise<void>;
    loading: boolean;
  };
}

export const CancelUploadModal: React.FunctionComponent<ICancelUploadModalProps> = ({
  open,
  handleContinue,
  handleCancel,
  rollback,
}) => {
  const { update: _handleRollback, loading: rollbackLoading } = rollback;

  // closes inspection modal AFTER deleting inspections and tasks
  const handleRollback = async () => {
    // deletes inspections/tasks
    await _handleRollback();

    // close cancel upload modal AND inspection upload modal
    handleCancel();
  };

  return (
    <StyledModal
      data-testid="upload-inspection-data-cancel-modal"
      title={'Cancel Inspection Upload'}
      open={open}
      onCancel={handleContinue}
      footer={null}
      maskClosable={false}
      destroyOnHidden
    >
      <ModalBody>
        <div>
          Are you sure you want to cancel the Inspection upload? If Inspections have been created,
          they may be incomplete and will not be removed unless you roll back their creation.
        </div>
        <ButtonContainer>
          <Button type="primary" danger={true} onClick={handleRollback} loading={rollbackLoading}>
            Roll Back Changes
          </Button>
          <Button onClick={handleCancel}>Cancel Upload</Button>
          <Button type="primary" onClick={handleContinue}>
            Continue Upload
          </Button>
        </ButtonContainer>
      </ModalBody>
    </StyledModal>
  );
};
